import Http from '@/Http/Request';
import { useQuery } from 'react-query';
import { ModuleListParams, ModuleListResponse } from './types';

const getModuleList = async (payload: ModuleListParams) => {
	console.log('payload', payload);
	const { data } = await Http({
		method: 'GET',
		url: 'getModuleListApi',
		params: payload
	});
	return data;
};

const useModuleList = (payload: ModuleListParams) => {
	console.log('useModuleList payload', payload);
	const { data: response, isLoading, error, refetch } = useQuery<ModuleListResponse, Error>({
		queryKey: ['moduleList', payload],
		queryFn: () => getModuleList(payload),
		keepPreviousData: true
	});
	const data = response?.data || {} as ModuleListResponse['data']
	const result: ModuleListResponse = {
		data: {
			list: data.list || [],
			page: data.page || 0,
			pageSize: data.pageSize || 0,
			total: data.total || 0,
		},
		message: response?.message || '',
		status: response?.status || 0
		
	};
	
	return { data: result, isLoading, error, refetch };
};

export default useModuleList;
